import React from 'react';
import {twMerge} from 'tailwind-merge';

import {ContentWrapper} from '../../Layout';
import {Article} from '..';

const ArticlePageLayout = (props) => {
    const {containerClassName, ...rest} = props;

    return (
        <ContentWrapper className={twMerge('py-10 lg:pt-[88px]', containerClassName)}>
            <Article {...rest} />
        </ContentWrapper>
    );
};

export default ArticlePageLayout;
